/**
 * apiFetch — drop-in replacement for fetch() that automatically attaches
 * the authenticated user's JWT as a Bearer token on every API call.
 *
 * Usage:  import { apiFetch } from '../../api/apiFetch';
 *         const res = await apiFetch('/api/v1/knowledge/stats');
 *         const res = await apiFetch('/api/v1/knowledge/ingest', {
 *           method: 'POST', body: formData
 *         });
 */

const TOKEN_KEY = 'mh_kc_token';

export function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = sessionStorage.getItem(TOKEN_KEY);
  const authHeaders: HeadersInit = token
    ? { Authorization: `Bearer ${token}` }
    : {};

  return fetch(url, {
    ...options,
    headers: {
      ...authHeaders,
      ...(options.headers ?? {}),
    },
  });
}
